module.exports = __webpack_public_path__ + "img/cheeks.deb03b24.svg";